module.exports = __webpack_public_path__ + "static/onions-544d03a0f0c429ca01a9142ca63a1162.jpg";